import React, { useState } from 'react';
import { FaChevronRight } from 'react-icons/fa';
import CreditData from '../components/credit/CreditData';
import PnLCorrelations from '../components/pnl/PnLCorrelations';
import './Credit.css';
import PageShell from '../components/layout/PageShell';

const Credit: React.FC = () => {
  const [expandedCard, setExpandedCard] = useState<string | null>(null);

  const toggleExpand = (card: string): void => {
    setExpandedCard(prev => (prev === card ? null : card));
  };

  return (
    <PageShell className={expandedCard ? 'blurred' : ''}>

      <div className="treelist-container">
        <div className={`treelist-card ${expandedCard === 'desk1' ? 'expanded' : ''}`}>
          <FaChevronRight
            className={`expand-arrow ${expandedCard === 'desk1' ? 'rotated' : ''}`}
            onClick={() => toggleExpand('desk1')}
          />
          <h2 className="card-title">Credit Data</h2>
          <CreditData />
        </div>

        <div className={`treelist-card ${expandedCard === 'desk2' ? 'expanded' : ''}`}>
          <FaChevronRight
            className={`expand-arrow ${expandedCard === 'desk2' ? 'rotated' : ''}`}
            onClick={() => toggleExpand('desk2')}
          />
          <h2 className="card-title">Credit Risk</h2>
          <PnLCorrelations />
        </div>
      </div>
    </PageShell>
  );
};

export default Credit;
